import Modal from './Modal'
import { openPhoneSettings, setReminder, useReminders, type ReminderKind } from '../lib/storeApp'

const OPTIONS: { kind: ReminderKind; label: string; hint: string }[] = [
  {
    kind: 'weekly',
    label: 'Weekly check-in',
    hint: 'Sundays at 6pm: update your budget vs actuals and add any one-offs.',
  },
  {
    kind: 'monthly',
    label: 'Monthly statement',
    hint: 'The 1st of each month at 6pm: upload a statement and reconcile.',
  },
]

/**
 * The reminder notifications (SM-33). Only offered inside the store apps,
 * which schedule them on the phone; this just switches them on and off.
 */
export default function RemindersModal({ onClose }: { onClose: () => void }) {
  const state = useReminders()
  const blocked = state?.permission === 'denied'

  return (
    <Modal title="Reminders" onClose={onClose}>
      {!state ? (
        <p className="text-sm text-ink/70 mb-4">Loading…</p>
      ) : (
        <>
          {OPTIONS.map(({ kind, label, hint }) => (
            <label key={kind} className="flex items-start gap-3 mb-4">
              <input
                type="checkbox"
                className="mt-1"
                checked={state[kind]}
                disabled={blocked && !state.canAsk}
                onChange={(e) => setReminder(kind, e.target.checked)}
              />
              <span>
                <span className="block text-sm text-ink">{label}</span>
                <span className="block text-xs text-ink/70">{hint}</span>
              </span>
            </label>
          ))}
          {blocked && (
            <p role="alert" className="text-sm text-ink/80 mb-4">
              Notifications are turned off for Snapshot Money on this phone.{' '}
              <button type="button" onClick={openPhoneSettings} className="text-accent hover:underline">
                Open settings
              </button>{' '}
              to allow them.
            </p>
          )}
        </>
      )}
      <div className="flex justify-end pt-3 border-t border-line">
        <button type="button" onClick={onClose} className="px-3 py-1.5 text-sm rounded-sm border border-line text-ink/80 hover:bg-paper">
          Done
        </button>
      </div>
    </Modal>
  )
}
